import caretDown from "../assets/icons/caret_down.svg";

interface CaretIconProps {
  customStyles?: React.CSSProperties;
}

const CaretIcon = ({ customStyles, ...rest }: CaretIconProps) => (
  <img
    alt="caret down"
    width="16px"
    height="16px"
    src={caretDown}
    {...rest}
    style={{ ...{ marginRight: "16px", }, ...customStyles }}
  />
);

export default CaretIcon;
